import Contact from '../components/Contact/Index'
import ContactComplete from '../components/Contact/Complete'

export default [
  {
    path: '/client/contact',
    name: 'contact',
    component: Contact,
    meta: {
      sideMenuId: 'contact',
    },
  },
  {
    path: '/client/contact',
    name: 'contact-confirm',
    component: Contact,
    meta: {
      sideMenuId: 'contact',
    },
  },
  {
    path: '/client/contact/complete',
    name: 'contact-complete',
    component: ContactComplete,
    meta: {
      sideMenuId: 'contact',
    },
  },
]
